import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as C } from "./SvgIcon.js";
const m = (r) => /* @__PURE__ */ o(C, { ...r, children: /* @__PURE__ */ o("path", { d: "M11.0058 5.24418C10.6804 4.91877 10.1529 4.91877 9.82749 5.24418L1.91083 13.1609C1.58541 13.4863 1.58541 14.0138 1.91083 14.3392C2.23624 14.6646 2.76374 14.6646 3.08916 14.3392L10.4167 7.01168L17.7442 14.3392C17.9071 14.5021 18.12 14.5834 18.3333 14.5834C18.5467 14.5834 18.7596 14.5021 18.9225 14.3392C19.2479 14.0138 19.2479 13.4863 18.9225 13.1609L11.0058 5.24418Z" }) });
export {
  m as CaretUp
};
//# sourceMappingURL=CaretUp.js.map
